import React from 'react';
import { IconPropsWithOrientation } from '../../icons';
import { SvgContainerWithOrientation } from '../../Icons.styles';

const ORIENTATION_MAP = {
  up: 'rotate(0deg)',
  down: 'rotate(180deg)',
  left: 'rotate(-90deg)',
  right: 'rotate(90deg)',
  upRight: 'rotate(45deg)',
  downRight: 'rotate(-45deg)',
  upLeft: 'rotate(-45deg)',
  downLeft: 'rotate(45deg)',
};

const SvgContainer = SvgContainerWithOrientation(ORIENTATION_MAP);

const Arrow = ({
  width = 25,
  color = 'var(--gray-light-400)',
  orientation = 'left',
  className = '',
}: IconPropsWithOrientation): JSX.Element => (
  <SvgContainer
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    viewBox='0 0 24 24'
    fill='none'
    $orientation={orientation}
    className={className}
  >
    <path
      d='M12 19V5M12 5L5 12M12 5L19 12'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </SvgContainer>
);

export default Arrow;
